import React, { useState, useEffect } from 'react';
import './Management.css';
import ManagementTableSkeleton from './Components/ManagementTableSkeleton';
import {
   Table, Space, Tooltip, Button, Select, Input, Row, Col, Tag,
   Modal, Typography, Spin, Popconfirm, InputNumber, Form, Empty
} from 'antd';
import ResponsiveBreadcrumb from '../../components/breadcrumb/ResponsiveBreadcrumb';
// import * as AntDIcons from '@ant-design/icons';
import { SearchOutlined, EditOutlined, PlusOutlined, DatabaseOutlined, OrderedListOutlined } from '@ant-design/icons';
import { useNavigate, Link } from 'react-router-dom';
import NoticeBoardSlide from '../../components/notice-board/NoticeBoardSlide';
import Highlighter from 'react-highlight-words';
import axios from 'axios';
import Utils from '../../misc/Utils';
import Enums from '../../misc/Enums';
import SimpleBarReact from "simplebar-react";
import ReactHtmlParser from "react-html-parser";

const { Option } = Select;
const { Text } = Typography;

export function Levels() {
   const navigate = useNavigate();

   const [searchText, setSearchText] = React.useState("");
   const [searchedColumn, setSearchedColumn] = React.useState("");

   const [acadLevelList, setAcadLevelList] = useState([]);
   const [levelList, setLevelList] = useState([]);
   const [sectionList, setSectionList] = useState([]);
   const [levelListPromote, setLevelListPromote] = useState([]);
   const [searchLoading, setSearchLoading] = useState(false);

   const [updating, setUpdating] = useState(false);
   const [editModalVisible, setEditModalVisible] = useState(false);
   const [addModalVisible, setAddModalVisible] = useState(false);

   const [acadLevel, setAcadLevel] = useState(null);
   const [level, setLevel] = useState(null);
   const [levelDesc, setLevelDesc] = useState(null);
   const [levelSequence, setLevelSequence] = useState(null);
   const [levelPromote, setLevelPromote] = useState(null);
   const [levelActive, setLevelActive] = useState(null);
   const [selectedSections, setSelectedSections] = useState([]);

   const user_id = Utils.getCurrentUserInfo(Enums.UserInfo.id);
   const user_role = Utils.getCurrentUserInfo(Enums.UserInfo.role);

   useEffect(() => {
      Utils.verifyJwt();

      // if (user_role.toLowerCase() !== 'admin' && user_role.toLowerCase() !== 'teacher')
      const allowedRoles = ['super admin', 'admin'];
      if (!allowedRoles.includes(user_role.toLowerCase()))
         navigate('/home');

      GetLookUps();
   }, []);

   const GetLookUps = () => {
      GetLevelList();
      GetAcadProgramList();
      GetSectionList();
   }

   const handleSearch = (selectedKeys, confirm, dataIndex) => {
      confirm();
      setSearchText(selectedKeys[0]);
      setSearchedColumn(dataIndex);
   };

   const handleReset = clearFilters => {
      clearFilters();
      setSearchText("");
   };

   const getColumnSearchProps = dataIndex => ({
      filterDropdown: ({ setSelectedKeys, selectedKeys, confirm, clearFilters }) => (
         <div style={{ padding: 8 }}>
            <Input
               ref={node => {
                  //this.searchInput(node);
               }}
               placeholder={`Search ${dataIndex}`}
               value={selectedKeys[0]}
               onChange={e => setSelectedKeys(e.target.value ? [e.target.value] : [])}
               onPressEnter={() => handleSearch(selectedKeys, confirm, dataIndex)}
               style={{ width: 188, marginBottom: 8, display: 'block' }}
            />
            <Space>
               <Button
                  type="primary"
                  onClick={() => handleSearch(selectedKeys, confirm, dataIndex)}
                  icon={<SearchOutlined />}
                  size="small"
                  style={{ width: 90 }}>
                  Search
               </Button>
               <Button
                  size="small"
                  style={{ width: 90 }}
                  // onClick={() => handleReset(clearFilters)} size="small" style={{ width: 90 }}
                  onClick={() => {
                     handleReset(clearFilters);
                     confirm({ closeDropdown: false });
                     setSearchText(selectedKeys[0]);
                     setSearchedColumn(dataIndex);
                  }}
               >
                  Reset
               </Button>
            </Space>
         </div>
      ),
      filterIcon: filtered => <SearchOutlined style={{ color: filtered ? '#033D89' : undefined }} />,
      onFilter: (value, record) =>
         record[dataIndex]
            ? record[dataIndex].toString().toLowerCase().includes(value.toLowerCase())
            : '',
      // onFilterDropdownVisibleChange: visible => {
      //    if (visible) {
      //       setTimeout(() => this.searchInput.select(), 100);
      //    }
      // },
      render: text =>
         searchedColumn === dataIndex ? (
            <Highlighter
               highlightStyle={{ backgroundColor: '#ffc069', padding: 0 }}
               searchWords={[searchText]}
               autoEscape
               textToHighlight={text ? text.toString() : ''}
            />
         ) : (
            text
         ),
   });

   const columns = [
      {
         title: 'Level',
         key: 'level_desc',
         ...getColumnSearchProps('level_desc'),
         ellipsis: {
            showTitle: false,
         },
         render: payload => (
            <Tooltip placement="topLeft" title={payload.level_desc}>
               <Text>
                  {
                     payload.level_desc
                  }
               </Text>
            </Tooltip>
         ),
         width: '20%'
      },
      {
         title: 'Education Level',
         key: 'academic_program_desc',
         ...getColumnSearchProps('academic_program_desc'),
         ellipsis: {
            showTitle: false,
         },
         render: payload => (
            <Tooltip placement="topLeft" title={payload.academic_program_desc}>
               <Text>
                  {
                     payload.academic_program_desc
                  }
               </Text>
            </Tooltip>
         ),
         width: '12%'
      },
      {
         title: 'Sequence',
         dataIndex: 'sort_order',
         key: 'sort_order',
         width: '8%'
      },
      {
         title: 'Promotion Level',
         key: 'promote_to_level_desc',
         ...getColumnSearchProps('promote_to_level_desc'),
         ellipsis: {
            showTitle: false,
         },
         render: payload => (
            <Tooltip placement="topLeft" title={payload.promote_to_level_desc}>
               <Text>
                  {
                     payload.promote_to_level_desc
                  }
               </Text>
            </Tooltip>
         ),
         width: '20%'
      },
      {
         title: 'Sections Assigned',
         key: 'assigned_sections_desc',
         ...getColumnSearchProps('assigned_sections_desc'),
         ellipsis: {
            showTitle: false,
         },
         render: payload => (
            // <Tooltip placement="topLeft" title={payload.assigned_sections_desc}>
            <Text>
               {
                  (payload.assigned_sections_desc !== undefined && payload.assigned_sections_desc !== "" && payload.assigned_sections_desc !== null) &&
                  <div 
                     // dangerouslySetInnerHTML={{ __html: payload.assigned_sections_desc.replace(new RegExp(',', 'g'), '<br />') }} 
                     style={{ textOverflow: 'ellipsis', overflow: 'hidden' }} 
                  >
                     {ReactHtmlParser(payload.assigned_sections_desc.replace(new RegExp(',', 'g'), '<br />'))}
                  </div>
               }
            </Text>
            // </Tooltip>
         ),
         width: '28%'
      },
      {
         title: 'Active',
         key: 'is_active',
         dataIndex: 'is_active',
         sorter: (a, b) => { return a.is_active.localeCompare(b.is_active) },
         render: is_active => (
            <Tag style={{ fontSize: 12 }} color={is_active === 'no' ? 'red' : 'green'}>
               {is_active.toUpperCase()}
            </Tag>
         ),
         width: '6%'
      },
      {
         title: 'Action',
         key: 'action',
         render: payload => {
            return <>
               <Space size="small">
                  <Tooltip placement="top" title='Edit Level'>
                     <EditOutlined color='#033D89' style={{ cursor: 'pointer' }} onClick={() => handleEdit(payload.id, payload.level_desc, payload.is_active, payload.sort_order, payload.promote_to_level, payload.assigned_sections, payload.academic_program)} />
                  </Tooltip>
               </Space>
            </>
         },
         width: '6%'
      },
   ].filter(item => !item.hidden);

   const section_columns = [
      {
         title: '',
         dataIndex: 'id',
         key: 'id',
         hidden: true,
      },
      {
         title: 'Section',
         key: 'section_desc',
         ...getColumnSearchProps('section_desc'),
         ellipsis: {
            showTitle: false,
         },
         render: payload => (
            <Tooltip placement="topLeft" title={payload.section_desc}>
               <Text>
                  {
                     payload.section_desc
                  }
               </Text>
            </Tooltip>
         ),
         width: '100%'
      },
   ].filter(item => !item.hidden);

   const GetAcadProgramList = () => {
      axios.get(`${process.env.REACT_APP_API_LOOKUP}/acadproglist`).then((response) => {
         if (response.data) {
            const data = response.data;

            setAcadLevelList(data);
         }
      }, (error) => {
         setSearchLoading(false);
         // console.log(error.message);
      });
   }
   const GetLevelList = () => {
      setSearchLoading(true);

      axios.get(`${process.env.REACT_APP_API_MANAGEMENT}/getlevellist`).then((response) => {
         if (response.data) {
            const data = response.data;

            var sectionlist = [];
            data.map((item) => {
               let obj = { 'value': item.id, 'name': item.level_desc }
               sectionlist.push(obj);
            });

            setLevelListPromote(sectionlist);

            setLevelList(data);
            setSearchLoading(false);
         }
      }, (error) => {
         setSearchLoading(false);
         console.log(error.message);
      });
   }

   const GetSectionList = () => {
      setSearchLoading(true);

      axios.get(`${process.env.REACT_APP_API_MANAGEMENT}/getsectionlist`).then((response) => {
         if (response.data) {
            const data = response.data;

            for (var i = 0; i < data.length; i++) {
               data[i].key = data[i].id;
            }

            setSectionList(data);

            setSearchLoading(false);
         }
      }, (error) => {
         setSearchLoading(false);
         console.log(error.message);
      });
   }

   const handleAddNewLevel = () => {
      // GetAcadProgramList();
      // GetSectionList();
      setLevel(null);
      setLevelDesc(null);
      setLevelActive(null);
      setLevelSequence(null);
      setLevelPromote(null);
      setSelectedSections(null);

      setAddModalVisible(true);
   }

   const handleEdit = (id, desc, active, sequence, promote_level, sections, acad_program) => {
      // GetAcadProgramList();
      // GetSectionList();
      setLevel(id);
      setLevelDesc(desc);
      setLevelActive(active);
      setLevelSequence(sequence);
      setLevelPromote(promote_level);
      setAcadLevel(acad_program);
      setSelectedSections(sections !== null ? sections.split(',').map(Number) : []);

      setEditModalVisible(true);
   }

   const handleSave = () => {
      if (levelDesc !== null && acadLevel !== null && levelSequence !== null && selectedSections !== null &&
         levelDesc !== '' && acadLevel !== '' && levelSequence !== '' && selectedSections !== '') {
         setUpdating(true);

         var levelData = {
            level_desc: levelDesc,
            sort_order: levelSequence,
            promote_to_level: levelPromote === null ? 100 : levelPromote,
            assigned_sections: selectedSections !== null ? selectedSections.join(',') : '',
            academic_program: acadLevel,
         }

         var url = `${process.env.REACT_APP_API_MANAGEMENT}/createlevel`;

         axios.post(url, levelData).then((response) => {
            if (response.data) {
               const data = response.data;

               GetLevelList();
               setUpdating(false);
               // setEditModalVisible(false);
               // setAddModalVisible(false);

               Modal.success({
                  title: 'Level Management',
                  content: 'Add successful.',
                  centered: true,
                  onOk: () => { handleCancel() },
               });
            }
         }, (error) => {
            setUpdating(false);
            Modal.error({
               title: 'Level Management',
               content: error.response.data,
               centered: true,
            });
         });
      } else {
         Modal.info({
            title: 'Student Management',
            content: (
               <>
                  Please complete the folowing before saving:
                  <ul>
                     <li>
                        New Grade Level
                     </li>
                     <li>
                        Education Level
                     </li>
                     <li>
                        Sequence Order
                     </li>
                     <li>
                        Assign Sections
                     </li>
                  </ul>
               </>),
            centered: true,
         });
      }
   }

   const handleCancel = () => {
      setEditModalVisible(false);
      setAddModalVisible(false);
   }

   const handleUpdate = () => {
      if (levelDesc !== null && acadLevel !== null && levelSequence !== null && selectedSections !== null &&
         levelDesc !== '' && acadLevel !== '' && levelSequence !== '' && selectedSections !== '') {
         setUpdating(true);

         var levelData = {
            id: level,
            level_desc: levelDesc,
            is_active: levelActive,
            sort_order: levelSequence,
            promote_to_level: levelPromote === null ? 100 : levelPromote,
            assigned_sections: selectedSections.join(','),
            academic_program: acadLevel,
         }

         var url = `${process.env.REACT_APP_API_MANAGEMENT}/updatelevel`;

         axios.post(url, levelData).then((response) => {
            if (response.data) {
               const data = response.data;

               GetLevelList();
               setUpdating(false);
               // setEditModalVisible(false);
               // setAddModalVisible(false);

               Modal.success({
                  title: 'Level Management',
                  content: 'Update successful.',
                  centered: true,
                  onOk: () => { handleCancel() },
               });
            }
         }, (error) => {
            setUpdating(false);
            Modal.error({
               title: 'Level Management',
               content: error.response.data,
               centered: true,
            });
         });

         // GetLevelList();
         // setUpdating(false);
         // setEditModalVisible(false);
         // setAddModalVisible(false);
      } else {
         Modal.info({
            title: 'Student Management',
            content: (
               <>
                  Please complete the folowing before saving:
                  <ul>
                     <li>
                        Grade Level
                     </li>
                     <li>
                        Education Level
                     </li>
                     <li>
                        Sequence Order
                     </li>
                     <li>
                        Assign Sections
                     </li>
                  </ul>
               </>),
            centered: true,
         });
      }
   }

   const handleRemove = (id) => {
      setUpdating(true);

      axios.post(`${process.env.REACT_APP_API_MANAGEMENT}/deletelevel?id=${id}`).then((response) => {
         if (response.data) {
            const data = response.data;

            GetLevelList();
            setUpdating(false);
            // setEditModalVisible(false);
            // setAddModalVisible(false);

            Modal.success({
               title: 'Level Management',
               content: 'Remove successful.',
               centered: true,
               onOk: () => { handleCancel() },
            });
         }
      }, (error) => {
         console.log(error.message);
         Modal.error({
            title: 'Level Management',
            content: error.response.data,
            centered: true,
         });
      });
   }

   const rowSelection = {
      selectedRowKeys: selectedSections,
      onChange: (selectedRowKeys, selectedRows) => {
         setSelectedSections(selectedRowKeys);
      },
   };

   return (
      <>
         <div className="dashboard-area-all management-page">
            <div className="dashboard-item management-shell">
               <div className="management-breadcrumb">
                  <ResponsiveBreadcrumb
                     items={[
                        { key: 'home', node: <Link to="/home">Home</Link> },
                        { key: 'management', node: 'Management' },
                        { key: 'levels', node: 'Levels' },
                     ]}
                  />
               </div>

               <section className="management-hero">
                  <div>
                     <Text className="management-kicker">Management</Text>
                     <h1>Levels</h1>
                     <p>Manage academic levels, sequencing, and related section mappings for school records.</p>
                     <div className="management-meta">
                        <span><OrderedListOutlined /> Academic levels</span>
                        <span><DatabaseOutlined /> {searchLoading ? 'Loading records' : `${levelList.length} records`}</span>
                     </div>
                  </div>
                  <div className="management-actions">
                     <Button className='management-create-btn button-shadow' type="primary" size="large" shape='round' onClick={() => handleAddNewLevel()}>
                        <PlusOutlined /> Add New Level
                     </Button>
                  </div>
               </section>

               <section className="management-panel">
                  <div className="management-table-shell">
                     {
                        searchLoading
                           ?
                           <ManagementTableSkeleton />
                           :
                           (levelList.length > 0 && !searchLoading)
                              ?
                              <Table
                                 className="management-table"
                                 rowKey={'uid'}
                                 // loading={searchLoading}
                                 size='small'
                                 columns={columns}
                                 dataSource={levelList}
                                 pagination={false}
                                 scroll={{
                                    y: 'calc(100svh - 12rem)',
                                    x: '1000px'
                                 }}
                                 footer={() => <div className="management-table-footer"><span>Total Records: {levelList.length}</span></div>}
                                 components={{
                                    body: {
                                       cell: props => {
                                          const { children, ...restProps } = props;
                                          return (
                                             <td {...restProps} style={{ alignContent: 'flex-start' }}>
                                                <div>
                                                   {children}
                                                </div>
                                             </td>
                                          );
                                       }
                                    }
                                 }}
                              />
                              :
                              <div className='management-empty-state'>
                                 <Empty image="../images/brainee_mascot.png" description="No records found" />
                              </div>
                     }

                  </div>
               </section>
            </div>
         </div>

         {/* Modals */}
         <Modal
            className="management-modal"
            title={"Add New Level"}
            centered
            destroyOnClose={true}
            onCancel={() => { handleCancel(); }}
            onOk={() => { handleSave() }}
            open={addModalVisible}
            width='40%'
            style={{ minWidth: '300px' }}
            okButtonProps={{ shape: 'round' }}
            cancelButtonProps={{ shape: 'round' }}
            okText={'Save'}
         >
            <Spin spinning={updating} tip={"Processing, please wait..."}>
               {/* <SimpleBarReact style={{ height: 'calc(100vh - 180px)' }}> */}
               <Form
                  layout={"vertical"}
                  colon={false}
                  style={{ width: '100%' }}
               >
                  <Row gutter={12}>
                     <Col sm={24} md={12} lg={12}>
                        <Form.Item name="level" label="New Grade Level"
                           rules={[{
                              required: true,
                              message: 'Required'
                           }]}
                        >
                           <Input
                              allowClear
                              size='middle'
                              style={{ borderRadius: 7 }}
                              placeholder="Enter New Level"
                              onBlur={(event) => { setLevelDesc(event.target.value) }}
                           />
                        </Form.Item>
                     </Col>
                     <Col sm={24} md={12} lg={12}>
                        <Form.Item name="acadlevel" label="Education Level"
                           rules={[{
                              required: true,
                              message: 'Required'
                           }]}
                        >
                           <Select
                              showArrow
                              size='middle'
                              allowClear
                              placeholder="Select Education Level"
                              onChange={(val) => setAcadLevel(val)}
                              style={{ width: '100%' }}
                           >
                              {acadLevelList.map(({ value, name }, idx) => {
                                 return <Option value={value}>{name}</Option>
                              })}
                           </Select>
                        </Form.Item>
                     </Col>
                  </Row>

                  <Row gutter={12}>
                     <Col sm={24} md={12} lg={12}>
                        <Form.Item name="promotion" label="Promotion Level">
                           <Select
                              showArrow
                              size='middle'
                              allowClear
                              placeholder="Select Level"
                              onChange={(val) => setLevelPromote(val)}
                              style={{ width: '100%' }}
                           >
                              {levelListPromote.map(({ value, name }, idx) => {
                                 return <Option value={value}>{name}</Option>
                              })}
                           </Select>
                        </Form.Item>
                     </Col>
                     <Col sm={24} md={12} lg={12}>
                        <Form.Item name="sequence" label="Sequence Order">
                           <InputNumber
                              key={'uid'}
                              size='middle'
                              style={{ borderRadius: 7, width: "100%" }}
                              min="1"
                              onChange={(val) => setLevelSequence(val)}
                           />
                        </Form.Item>
                     </Col>
                  </Row>

                  <Text>Assign Sections</Text>
                  <Table
                     rowSelection={rowSelection}
                     size='small'
                     columns={section_columns}
                     dataSource={sectionList}
                     pagination={false}
                     // style={{ minWidth: '300px' }}
                     scroll={{
                        // x: '1000px',
                        y: 'calc(100vh - 32rem)',
                     }}
                  />
               </Form>
               {/* </SimpleBarReact> */}
            </Spin>
         </Modal>

         <Modal
            className="management-modal"
            title={"Edit Level"}
            centered
            destroyOnClose={true}
            onCancel={() => { handleCancel(); }}
            onOk={() => { handleUpdate() }}
            open={editModalVisible}
            width='35%'
            style={{ minWidth: '300px' }}
            okButtonProps={{ shape: 'round' }}
            cancelButtonProps={{ shape: 'round' }}
            okText={'Update'}
         >
            <Spin spinning={updating} tip={"Processing, please wait..."}>
               <Form
                  layout={"vertical"}
                  colon={false}
                  style={{ width: '100%' }}
               >
                  <Row gutter={12}>
                     <Col sm={24} md={12} lg={12}>
                        <Form.Item name="level" label={<Text ellipsis>"New Grade Level"</Text>}
                           rules={[{
                              required: true,
                              message: 'Required'
                           }]}
                        >
                           <Input
                              allowClear
                              size='middle'
                              style={{ borderRadius: 7 }}
                              placeholder="Enter New Level"
                              onBlur={(event) => { setLevelDesc(event.target.value) }}
                              defaultValue={levelDesc}
                           />
                        </Form.Item>
                     </Col>
                     <Col sm={24} md={12} lg={12}>
                        <Form.Item name="acadlevel" label={<Text ellipsis>Education Level</Text>}
                           rules={[{
                              required: true,
                              message: 'Required'
                           }]}
                        >
                           <Select
                              showArrow
                              size='middle'
                              allowClear
                              placeholder="Select Education Level"
                              onChange={(val) => setAcadLevel(val)}
                              style={{ width: '100%' }}
                              defaultValue={acadLevel}
                           >
                              {acadLevelList.map(({ value, name }, idx) => {
                                 return <Option value={value}>{name}</Option>
                              })}
                           </Select>
                        </Form.Item>
                     </Col>
                  </Row>

                  <Row gutter={12}>
                     <Col sm={24} md={12} lg={12}>
                        <Form.Item name="promotion" label={<Text ellipsis>Promotion Level</Text>}>
                           <Select
                              showArrow
                              size='middle'
                              allowClear
                              placeholder="Select Level"
                              onChange={(val) => setLevelPromote(val)}
                              style={{ width: '100%' }}
                              defaultValue={levelPromote}
                           >
                              {levelListPromote.map(({ value, name }, idx) => {
                                 return <Option value={value}>{name}</Option>
                              })}
                           </Select>
                        </Form.Item>
                     </Col>
                     <Col sm={24} md={12} lg={12}>
                        <Form.Item name="sequence" label={<Text ellipsis>Sequence Order</Text>}>
                           <InputNumber
                              key={'uid'}
                              size='middle'
                              style={{ borderRadius: 7, width: "100%" }}
                              min="1"
                              onChange={(val) => setLevelSequence(val)}
                              defaultValue={levelSequence}
                           />
                        </Form.Item>
                     </Col>
                  </Row>

                  <Text>Assign Sections</Text>
                  <Table
                     rowSelection={rowSelection}
                     size='small'
                     columns={section_columns}
                     dataSource={sectionList}
                     pagination={false}
                     // style={{ minWidth: '300px' }}
                     scroll={{
                        // x: '1000px',
                        y: 'calc(100vh - 30rem)',
                     }}
                  />
               </Form>
            </Spin>
         </Modal>
      </>
   );
}
